// extracted by mini-css-extract-plugin
export default {"cardsContainer":"styles_cardsContainer__ep+vw","teamsGrid":"styles_teamsGrid__dmC9P"};